import script from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=40c78b8c&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c78b8c"]])

export default __exports__